import * as type from '../type'

const initialState = {
  exmaple: {
    data: {},
    isLoading: false,
  },
}

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}
